let siteLang = "ja"

const esc = (s) =>
  String(s)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")

const setText = (id, text) => {
  const el = document.getElementById(id)
  if (el && text != null) el.textContent = text
}

const setMeta = (id, val) => {
  const el = document.getElementById(id)
  if (el && val) el.setAttribute("content", val)
}

const insightKeywords = (article) => {
  if (article.keywords) return l(article.keywords)
  const parts = []
  if (article.tag) parts.push(l(article.tag))
  if (Array.isArray(article.tags)) parts.push(...article.tags)
  parts.push("NAPIRE", siteLang === "en" ? "NAPIRE Inc." : "株式会社NAPIRE")
  return [...new Set(parts.map((p) => String(p).trim()).filter(Boolean))].join(", ")
}

const l = (obj) => {
  if (!obj) return ""
  return obj[siteLang] || obj.ja || obj.en || ""
}

const showRevealsAfterLangSwitch = () => {
  document.querySelectorAll(".reveal:not(.is-visible)").forEach((el) => {
    el.classList.add("is-visible")
  })
}

const getPreferredLang = () => {
  try {
    return sessionStorage.getItem("napire-lang") === "en" ? "en" : "ja"
  } catch {
    return "ja"
  }
}

const savePreferredLang = (lang) => {
  try {
    sessionStorage.setItem("napire-lang", lang)
  } catch {
    /* ignore */
  }
}

const bindLangSwitch = () => {
  const jaBtn = document.getElementById("jaButton")
  const enBtn = document.getElementById("enButton")
  if (!jaBtn || !enBtn || jaBtn.dataset.langBound === "1") return
  jaBtn.dataset.langBound = "1"
  enBtn.dataset.langBound = "1"
  jaBtn.addEventListener("click", () => initSiteLang("ja", document.body.dataset.page))
  enBtn.addEventListener("click", () => initSiteLang("en", document.body.dataset.page))
}

const getWorkCases = () =>
  typeof WORK_CASES !== "undefined" ? WORK_CASES : dafaultLanguage.proof.cases

const workCaseImage = (item) => {
  const key = item.image
  if (key && NAPIRE_MEDIA.workCases && NAPIRE_MEDIA.workCases[key]) {
    return NAPIRE_MEDIA.workCases[key]
  }
  return NAPIRE_MEDIA.workThumb
}

const renderWorkCaseMarkup = (item, index) => {
  const highlights = (item.highlights || [])
    .map((h) => `<li>${esc(l(h))}</li>`)
    .join("")
  const num = String(index + 1).padStart(2, "0")
  return `
      <article class="work-case reveal">
        <div class="work-case__media">
          <img src="${workCaseImage(item)}" alt="" width="960" height="540" loading="lazy" />
          <span class="work-case__index" aria-hidden="true">${num}</span>
        </div>
        <div class="work-case__body">
          <p class="work-case__tag">${esc(l(item.tag))}</p>
          <h3 class="work-case__title">${esc(l(item.title))}</h3>
          <p class="work-case__desc">${esc(l(item.desc))}</p>
          ${highlights ? `<ul class="work-case__highlights">${highlights}</ul>` : ""}
        </div>
      </article>`
}

const renderSharedNav = () => {
  const n = dafaultLanguage.nav
  const nav = document.getElementById("site-nav")
  if (nav && !document.getElementById("nav-it-store")) {
    const link = document.createElement("a")
    link.className = "site-header__link"
    link.id = "nav-it-store"
    const productsLink = document.getElementById("nav-products")
    link.href = "/it-store.html"
    productsLink?.insertAdjacentElement("afterend", link)
  }
  const footerProducts = document.getElementById("footer-products")
  if (footerProducts && !document.getElementById("footer-it-store")) {
    const item = document.createElement("li")
    const link = document.createElement("a")
    link.id = "footer-it-store"
    link.href = "/it-store.html"
    item.appendChild(link)
    footerProducts.closest("li")?.insertAdjacentElement("afterend", item)
  }
  setText("nav-home", l(n.home))
  setText("nav-ai-dx", l(n.aiDx))
  setText("nav-saas-cloud", l(n.saasCloud))
  setText("nav-drone", l(n.drone))
  setText("nav-products", l(n.products))
  setText("nav-it-store", l(n.itStore))
  setText("nav-work", l(n.work))
  setText("nav-about", l(n.about))
  setText("nav-insights", l(n.insights))
  setText("nav-reports", l(n.reports))
  setText("nav-contact", l(n.contact))
  setText("nav-services-group", l(n.servicesGroup))
  setText("nav-company-group", l(n.companyGroup))
  setText("nav-drawer-title", l(n.drawerTitle))
  const menuBtn = document.getElementById("site-menu-btn")
  const closeBtn = document.getElementById("site-menu-close")
  if (menuBtn) menuBtn.setAttribute("aria-label", l(n.menuOpen))
  if (closeBtn) closeBtn.setAttribute("aria-label", l(n.close))
  setText("footer-tagline", l(dafaultLanguage.footer.tagline))
  setText("footer-services-title", l(n.servicesGroup))
  setText("footer-company-title", l(n.companyGroup))
  setText("footer-contact-title", l(n.contact))
  setText("footer-ai-dx", l(n.aiDx))
  setText("footer-saas", l(n.saasCloud))
  setText("footer-drone", l(n.drone))
  setText("footer-products", l(n.products))
  setText("footer-it-store", l(n.itStore))
  setText("footer-work", l(n.work))
  setText("footer-about", l(n.about))
  setText("footer-team", l(n.team))
  setText("footer-insights", l(n.insights))
  setText("footer-reports", l(n.reports))
  setText("footer-contact-link", l(dafaultLanguage.contact.formLink))
  document.querySelectorAll(".breadcrumb-home").forEach((el) => {
    el.textContent = l(dafaultLanguage.pages.breadcrumbHome)
  })
  document.getElementById("nav-it-store")?.classList.toggle(
    "site-header__link--active",
    document.body?.dataset?.page === "itStore"
  )
}

const renderFooterCompany = () => {
  const c = dafaultLanguage.company
  setText("company-name", l(c.name))
  setText("company-builtDate", l(c.builtDate))
  setText("company-place", l(c.place))
  setText("company-content", l(c.content))
  setText("company-capital", l(c.capital))
  setText("footer-company-name", l(c.name))
  setText("footer-company-place", l(c.place))
  setText("footer-company-content", l(c.content))
}

const renderHome = () => {
  const h = dafaultLanguage.home
  document.title = l(h.pageTitle)
  setMeta("meta-description", l(dafaultLanguage.metaDescription))
  setMeta("meta-keywords", l(dafaultLanguage.metaKeywords))
  setMeta("og-title", l(h.pageTitle))
  setMeta("og-description", l(dafaultLanguage.metaDescription))

  setText("home-hero-title", l(h.heroTitle))
  setText("home-hero-lead", l(h.heroLead))
  setText("home-hero-cta", l(h.heroCta))
  setText("home-hero-cta2", l(h.heroCta2))

  setText("home-services-label", l(h.servicesLabel))
  setText("home-services-title", l(h.servicesTitle))
  setText("home-services-lead", l(h.servicesLead))

  setText("card-ai-title", l(dafaultLanguage.solutions.aiDx.title))
  setText("card-ai-desc", l(dafaultLanguage.solutions.aiDx.desc))
  setText("card-ai-cta", l(dafaultLanguage.solutions.aiDx.cta))
  setText("card-cloud-title", l(dafaultLanguage.solutions.saasCloud.title))
  setText("card-cloud-desc", l(dafaultLanguage.solutions.saasCloud.desc))
  setText("card-cloud-cta", l(dafaultLanguage.solutions.saasCloud.cta))
  setText("card-drone-title", l(dafaultLanguage.drone.title))
  setText("card-drone-desc", l(dafaultLanguage.drone.lead))
  setText("card-drone-cta", siteLang === "ja" ? "詳しく見る" : "Learn more")

  setText("home-statement", l(dafaultLanguage.statement.mega))
  setText("home-statement-sub", l(dafaultLanguage.statement.sub))

  setText("home-about-label", l(h.aboutLabel))
  setText("home-about-title", l(h.aboutTitle))
  setText("home-about-lead", l(h.aboutLead))
  setText("home-about-cta", l(h.aboutCta))

  setText("home-questions-label", l(h.questionsLabel))
  setText("home-questions-title", l(h.questionsTitle))

  const qRoot = document.getElementById("home-questions")
  if (qRoot) {
    qRoot.innerHTML = dafaultLanguage.story.questions
      .map(
        (item, i) => `
      <article class="question-item reveal">
        <div>
          <p class="question-item__q">${esc(l(item.q))}</p>
          <p class="question-item__a">${esc(l(item.bridge))}</p>
        </div>
        <span class="question-item__num">${String(i + 1).padStart(2, "0")}</span>
      </article>`
      )
      .join("")
  }

  setText("home-featured-label", l(h.featuredLabel))
  setText("home-featured-title", l(h.featuredTitle))
  setText("home-featured-more", l(h.featuredMore))

  const fRoot = document.getElementById("home-featured")
  if (fRoot) {
    fRoot.innerHTML = getWorkCases()
      .slice(0, 3)
      .map(
        (item) => `
      <article class="card card--media card--work reveal">
        <div class="card__media">
          <img src="${workCaseImage(item)}" alt="" width="640" height="400" loading="lazy" />
        </div>
        <div class="card__body">
          <p class="card__tag">${esc(l(item.tag))}</p>
          <h3 class="card__title">${esc(l(item.title))}</h3>
          <p class="card__text">${esc(l(item.desc))}</p>
        </div>
      </article>`
      )
      .join("")
  }

  setText("home-insights-label", l(h.insightsLabel))
  setText("home-insights-title", l(h.insightsTitle))
  setText("home-insights-lead", l(h.insightsLead))
  setText("home-insights-more", l(h.insightsMore))
  const insightsRoot = document.getElementById("home-insights-list")
  if (insightsRoot) {
    const articles = getInsightArticles().slice(0, 3)
    insightsRoot.innerHTML = articles.length
      ? articles.map((a) => renderInsightCardMarkup(a)).join("")
      : `<p class="article-grid--empty">${esc(l(dafaultLanguage.insights.comingSoon))}</p>`
  }

  setText("home-reports-label", l(h.reportsLabel))
  setText("home-reports-title", l(h.reportsTitle))
  setText("home-reports-lead", l(h.reportsLead))
  setText("home-reports-more", l(h.reportsMore))
  const reportsRoot = document.getElementById("home-reports-list")
  if (reportsRoot) {
    const reports = getConsultingReportArticles().slice(0, 3)
    reportsRoot.innerHTML = reports.length
      ? reports.map((a) => renderConsultingReportCardMarkup(a)).join("")
      : `<p class="article-grid--empty">${esc(l(dafaultLanguage.consultingReports.comingSoon))}</p>`
  }

  setText("home-cta-title", l(dafaultLanguage.contact.heading))
  setText("home-cta-text", l(dafaultLanguage.contact.description))
  setText("contact-label", l(dafaultLanguage.contact.formLink))
  setText("home-cta-btn", l(dafaultLanguage.contact.buttonText))
}

const renderWork = () => {
  const p = dafaultLanguage.pages.work
  document.title = l(p.pageTitle)
  setMeta("meta-description", l(p.metaDescription))
  setMeta("meta-keywords", l(p.metaKeywords))
  setText("breadcrumb-current", l(dafaultLanguage.nav.work))
  setText("work-label", l(p.heroLabel))
  setText("work-title", l(dafaultLanguage.proof.title))
  setText("work-lead", l(dafaultLanguage.proof.subtitle))
  setText("work-cta-title", l(p.ctaTitle))
  setText("work-cta-text", l(p.ctaText))
  setText("work-cta-btn", l(dafaultLanguage.contact.buttonText))
  const root = document.getElementById("work-list")
  const cases = getWorkCases()
  if (root) {
    root.innerHTML = cases.map((item, i) => renderWorkCaseMarkup(item, i)).join("")
  }
}

const renderProductPanelMarkup = (item, index) => {
  const num = String(index + 1).padStart(2, "0")
  const chips = (item.highlights || [])
    .map((h) => `<li class="product-panel__chip">${esc(l(h))}</li>`)
    .join("")
  const visit = typeof PRODUCTS_PAGE !== "undefined" ? l(PRODUCTS_PAGE.visitLabel) : siteLang === "ja" ? "サイトを見る" : "Visit site"
  const appStoreLabel =
    typeof PRODUCTS_PAGE !== "undefined" ? l(PRODUCTS_PAGE.appStoreLabel) : "App Store"
  const googlePlayLabel =
    typeof PRODUCTS_PAGE !== "undefined" ? l(PRODUCTS_PAGE.googlePlayLabel) : "Google Play"
  const hint = typeof PRODUCTS_PAGE !== "undefined" ? l(PRODUCTS_PAGE.externalHint) : ""
  const image = item.ogImage
    ? `<img class="product-panel__image" src="${esc(item.ogImage)}" alt="" width="1200" height="630" loading="lazy" decoding="async" referrerpolicy="no-referrer" />`
    : ""
  const storeLinks = [
    item.appStoreUrl
      ? `<a class="product-panel__store product-panel__store--apple" href="${esc(item.appStoreUrl)}" target="_blank" rel="noopener noreferrer" title="${esc(hint)}">
          <span class="product-panel__store-icon" aria-hidden="true">
            <svg viewBox="0 0 24 24" width="18" height="18" focusable="false"><path fill="currentColor" d="M16.365 1.43c0 1.14-.42 2.2-1.18 3.03-.8.88-2.12 1.56-3.24 1.47-.14-1.1.42-2.26 1.17-3.08.8-.9 2.2-1.56 3.25-1.42zM20.5 17.2c-.58 1.3-.86 1.88-1.61 3.03-1.04 1.52-2.5 3.4-4.32 3.42-1.62.02-2.04-1.06-4.25-1.05-2.2.01-2.67 1.07-4.28 1.05-1.82-.02-3.21-1.73-4.25-3.25C.1 17.5-.9 13.04.86 10.02c.88-1.5 2.45-2.45 4.15-2.48 1.63-.03 3.17 1.1 4.25 1.1 1.07 0 2.74-1.36 4.62-1.16.79.03 3 .32 4.42 2.4-3.77 2.07-3.17 7.45.2 7.32z"/></svg>
          </span>
          <span class="product-panel__store-copy">
            <span class="product-panel__store-kicker">Download on the</span>
            <span class="product-panel__store-name">${esc(appStoreLabel)}</span>
          </span>
        </a>`
      : "",
    item.googlePlayUrl
      ? `<a class="product-panel__store product-panel__store--google" href="${esc(item.googlePlayUrl)}" target="_blank" rel="noopener noreferrer" title="${esc(hint)}">
          <span class="product-panel__store-icon" aria-hidden="true">
            <svg viewBox="0 0 24 24" width="18" height="18" focusable="false"><path fill="currentColor" d="M3.18 2.5c-.3.16-.5.47-.5.84v17.32c0 .37.2.68.5.84l9.93-9.5L3.18 2.5zm11.2 7.02L7.96 4.77l8.7 5.03-2.28-.28zm2.93 1.68l2.74 1.58c.78.45.78 1.57 0 2.02l-2.74 1.58-3.15-3.03 3.15-3.15zM7.96 19.23l6.42-4.75 2.28-.28-8.7 5.03z"/></svg>
          </span>
          <span class="product-panel__store-copy">
            <span class="product-panel__store-kicker">GET IT ON</span>
            <span class="product-panel__store-name">${esc(googlePlayLabel)}</span>
          </span>
        </a>`
      : "",
  ]
    .filter(Boolean)
    .join("")

  return `
    <article class="product-panel product-panel--${esc(item.theme)} reveal" id="product-${esc(item.id)}">
      <div class="product-panel__visual">
        ${image}
        <div class="product-panel__visual-overlay" aria-hidden="true"></div>
        <div class="product-panel__canvas" aria-hidden="true">
          <p class="product-panel__index">${num}</p>
        </div>
      </div>
      <div class="product-panel__body">
        <p class="product-panel__category">${esc(l(item.category))}</p>
        <h2 class="product-panel__name">${esc(l(item.name))}</h2>
        <p class="product-panel__tagline">${esc(l(item.tagline))}</p>
        <p class="product-panel__desc">${esc(l(item.desc))}</p>
        ${chips ? `<ul class="product-panel__highlights">${chips}</ul>` : ""}
        <div class="product-panel__actions">
          <a class="product-panel__cta" href="${esc(item.url)}" target="_blank" rel="noopener noreferrer" title="${esc(hint)}">
            ${esc(visit)}
            <span aria-hidden="true">→</span>
          </a>
          ${storeLinks ? `<div class="product-panel__stores">${storeLinks}</div>` : ""}
        </div>
      </div>
    </article>`
}

const renderProducts = () => {
  const p = typeof PRODUCTS_PAGE !== "undefined" ? PRODUCTS_PAGE : null
  if (!p) return
  const products = typeof getProducts === "function" ? getProducts() : []

  document.title = l(p.pageTitle)
  setMeta("meta-description", l(p.metaDescription))
  setMeta("meta-keywords", l(p.metaKeywords))
  setMeta("og-title", l(p.pageTitle))
  setMeta("og-description", l(p.metaDescription))
  setText("breadcrumb-current", l(dafaultLanguage.nav.products))
  setText("products-label", l(p.heroLabel))
  setText("products-brand", l(p.heroBrand))
  setText("products-title", l(p.heroTitle))
  setText("products-lead", l(p.heroLead))
  setText("products-cta", l(p.heroCta))
  setText("products-cta2", l(p.heroCta2))
  setText("products-count", String(products.length))
  setText("products-count-label", l(p.countLabel))
  setText("products-jump-label", l(p.jumpLabel))
  setText("products-philosophy-label", l(p.philosophyLabel))
  setText("products-philosophy-title", l(p.philosophyTitle))
  setText("products-philosophy-text", l(p.philosophyText))
  setText("products-cta-title", l(p.ctaTitle))
  setText("products-cta-text", l(p.ctaText))
  setText("products-cta-btn", l(p.ctaBtn))

  const jump = document.getElementById("products-jump-list")
  if (jump) {
    jump.innerHTML = products
      .map(
        (item) => `
      <li>
        <a class="products-jump__link" href="#product-${esc(item.id)}">${esc(l(item.name))}</a>
      </li>`
      )
      .join("")
  }

  const root = document.getElementById("products-showcase")
  if (root) {
    root.innerHTML = products.map((item, i) => renderProductPanelMarkup(item, i)).join("")
  }
}

const storeCatalogState = {
  category: "all",
  query: "",
  sort: "recommended",
  selected: new Set(),
}

const storeProductIcon = (type) => {
  if (type === "laptop") {
    return `<svg class="store-product__icon" viewBox="0 0 320 220" role="img" aria-label="Laptop illustration">
      <rect x="54" y="24" width="212" height="142" rx="10" fill="white" stroke="currentColor" stroke-width="7" />
      <rect x="68" y="38" width="184" height="114" rx="4" fill="currentColor" opacity="0.1" />
      <path d="M25 180h270l-19 22H44z" fill="white" stroke="currentColor" stroke-width="7" stroke-linejoin="round" />
      <path d="M128 182h64" stroke="currentColor" stroke-width="6" stroke-linecap="round" opacity="0.45" />
    </svg>`
  }

  if (type === "monitor") {
    return `<svg class="store-product__icon" viewBox="0 0 320 220" role="img" aria-label="Monitor illustration">
      <rect x="42" y="25" width="236" height="145" rx="12" fill="white" stroke="currentColor" stroke-width="7" />
      <rect x="58" y="41" width="204" height="113" rx="5" fill="currentColor" opacity="0.1" />
      <path d="M160 171v24M116 199h88" stroke="currentColor" stroke-width="8" stroke-linecap="round" />
    </svg>`
  }

  if (type === "mouse") {
    return `<svg class="store-product__icon" viewBox="0 0 320 220" role="img" aria-label="Mouse illustration">
      <rect x="102" y="22" width="116" height="176" rx="58" fill="white" stroke="currentColor" stroke-width="7" />
      <path d="M160 25v58" stroke="currentColor" stroke-width="7" />
      <rect x="151" y="48" width="18" height="38" rx="9" fill="currentColor" opacity="0.55" />
    </svg>`
  }

  if (type === "lock") {
    return `<svg class="store-product__icon" viewBox="0 0 320 220" role="img" aria-label="Security lock illustration">
      <path d="M113 95V70c0-32 20-52 47-52s47 20 47 52v25" fill="none" stroke="currentColor" stroke-width="11" stroke-linecap="round" />
      <rect x="82" y="88" width="156" height="112" rx="18" fill="white" stroke="currentColor" stroke-width="7" />
      <circle cx="160" cy="138" r="13" fill="currentColor" /><path d="M160 149v23" stroke="currentColor" stroke-width="9" stroke-linecap="round" />
    </svg>`
  }

  if (type === "filter") {
    return `<svg class="store-product__icon" viewBox="0 0 320 220" role="img" aria-label="Privacy filter illustration">
      <rect x="45" y="27" width="230" height="156" rx="10" fill="white" stroke="currentColor" stroke-width="7" />
      <rect x="65" y="47" width="190" height="116" rx="5" fill="currentColor" opacity="0.13" />
      <path d="M86 106c22-26 46-39 74-39s52 13 74 39c-22 26-46 39-74 39s-52-13-74-39z" fill="white" stroke="currentColor" stroke-width="7" />
      <circle cx="160" cy="106" r="22" fill="currentColor" opacity="0.65" />
    </svg>`
  }

  if (type === "adapter") {
    return `<svg class="store-product__icon" viewBox="0 0 320 220" role="img" aria-label="Adapter illustration">
      <rect x="55" y="67" width="102" height="86" rx="15" fill="white" stroke="currentColor" stroke-width="7" />
      <path d="M158 110h57c31 0 45-20 45-43" fill="none" stroke="currentColor" stroke-width="10" stroke-linecap="round" />
      <rect x="236" y="28" width="48" height="45" rx="8" fill="white" stroke="currentColor" stroke-width="7" />
      <path d="M80 94h52M80 112h52M80 130h52" stroke="currentColor" stroke-width="6" stroke-linecap="round" opacity="0.55" />
    </svg>`
  }

  if (type === "keyboard") {
    return `<svg class="store-product__icon" viewBox="0 0 320 220" role="img" aria-label="Keyboard illustration">
      <path d="M36 60h248l19 102H17z" fill="white" stroke="currentColor" stroke-width="7" stroke-linejoin="round" />
      <g fill="currentColor" opacity="0.45">${Array.from({ length: 28 }, (_, i) => `<rect x="${45 + (i % 10) * 23}" y="${80 + Math.floor(i / 10) * 23}" width="15" height="13" rx="2" />`).join("")}</g>
      <rect x="92" y="148" width="136" height="10" rx="5" fill="currentColor" opacity="0.45" />
    </svg>`
  }

  const colorBars = type === "printer-color"
    ? `<rect x="104" y="73" width="112" height="12" rx="6" fill="#2f4def" opacity="0.82" />
       <rect x="104" y="92" width="82" height="8" rx="4" fill="#0d9488" opacity="0.72" />
       <rect x="104" y="107" width="96" height="8" rx="4" fill="#d97706" opacity="0.68" />`
    : `<rect x="104" y="77" width="112" height="10" rx="5" fill="currentColor" opacity="0.6" />
       <rect x="104" y="95" width="88" height="8" rx="4" fill="currentColor" opacity="0.32" />`

  return `<svg class="store-product__icon" viewBox="0 0 320 220" role="img" aria-label="Printer illustration">
    <path d="M86 62V26h148v36" fill="white" stroke="currentColor" stroke-width="7" stroke-linejoin="round" />
    <rect x="48" y="59" width="224" height="111" rx="14" fill="white" stroke="currentColor" stroke-width="7" />
    <circle cx="241" cy="85" r="7" fill="currentColor" />
    <path d="M83 134h154v61H83z" fill="white" stroke="currentColor" stroke-width="7" stroke-linejoin="round" />
    ${colorBars}
  </svg>`
}

const renderStoreProductMarkup = (item) => {
  const price = new Intl.NumberFormat(siteLang === "en" ? "en-US" : "ja-JP").format(item.price)
  const productLabel = `${l(item.name)} (${item.model})`
  const quoteUrl = `contact.html?product=${encodeURIComponent(productLabel)}#contact-form-title`
  const productVisual = item.imageUrl
    ? `<img class="store-product__image" src="${esc(item.imageUrl)}" alt="${esc(`${item.maker} ${productLabel}`)}" width="640" height="440" loading="lazy" decoding="async" />`
    : storeProductIcon(item.type)
  const highlights = (item.highlights || [])
    .map((highlight) => `<li class="store-product__highlight">${esc(l(highlight))}</li>`)
    .join("")

  const isSelected = storeCatalogState.selected.has(item.id)

  return `<article class="store-product store-product--${esc(item.theme)} reveal" data-store-product="${esc(item.id)}">
    <div class="store-product__visual">
      <p class="store-product__maker">${esc(item.maker)}</p>
      ${item.featured ? `<span class="store-product__featured">${esc(l(IT_STORE_PAGE.featuredLabel))}</span>` : ""}
      ${productVisual}
    </div>
    <div class="store-product__body">
      <p class="store-product__category">${esc(l(item.category))}</p>
      <h3 class="store-product__name">${esc(l(item.name))}</h3>
      <p class="store-product__model">${esc(item.model)}</p>
      <p class="store-product__tagline">${esc(l(item.tagline))}</p>
      <p class="store-product__desc">${esc(l(item.desc))}</p>
      <ul class="store-product__highlights">${highlights}</ul>
      <div class="store-product__price-block">
        <div class="store-product__price-row">
          <span class="store-product__tax">${esc(l(IT_STORE_PAGE.taxIncluded))}</span>
          <span class="store-product__price">¥${price}</span>
        </div>
        <p class="store-product__shipping">${esc(l(IT_STORE_PAGE.shippingNote))}</p>
        <p class="store-product__stock">${esc(l(IT_STORE_PAGE.stockNote))}</p>
      </div>
      <div class="store-product__actions">
        <a class="store-product__quote" href="${quoteUrl}">${esc(l(IT_STORE_PAGE.quoteCta))}<span aria-hidden="true">→</span></a>
        <a class="store-product__maker-link" href="${esc(item.makerUrl)}" target="_blank" rel="noopener noreferrer">${esc(l(IT_STORE_PAGE.makerCta))}<span aria-hidden="true">↗</span></a>
      </div>
      <label class="store-product__compare">
        <input type="checkbox" value="${esc(item.id)}" data-store-compare ${isSelected ? "checked" : ""} />
        <span>${esc(l(IT_STORE_PAGE.compareToggle))}</span>
      </label>
    </div>
  </article>`
}

const getStoreVisibleProducts = (products) => {
  const query = storeCatalogState.query.trim().toLowerCase()
  const visible = products.filter((item) => {
    if (storeCatalogState.category !== "all" && item.group !== storeCatalogState.category) return false
    if (!query) return true
    const haystack = [item.maker, item.model, l(item.name), l(item.category), l(item.tagline), l(item.desc), ...(item.highlights || []).map(l)]
      .join(" ")
      .toLowerCase()
    return haystack.includes(query)
  })

  if (storeCatalogState.sort === "price-asc") return [...visible].sort((a, b) => a.price - b.price)
  if (storeCatalogState.sort === "price-desc") return [...visible].sort((a, b) => b.price - a.price)
  return visible
}

const closeStoreCompareModal = () => {
  const modal = document.getElementById("store-compare-modal")
  if (modal) modal.hidden = true
  document.body.classList.remove("store-compare-open")
}

const renderStoreCompareTable = (products) => {
  const selected = products.filter((item) => storeCatalogState.selected.has(item.id))
  const tableRoot = document.getElementById("store-compare-table")
  if (!tableRoot) return
  const row = (label, values, className = "") => `<tr><th scope="row">${esc(l(label))}</th>${values.map((value) => `<td class="${className}">${value}</td>`).join("")}</tr>`
  const names = selected.map((item) => `<strong>${esc(item.maker)}<br>${esc(l(item.name))}</strong><small>${esc(item.model)}</small>`)
  const categories = selected.map((item) => esc(l(item.category)))
  const prices = selected.map((item) => `¥${new Intl.NumberFormat(siteLang === "en" ? "en-US" : "ja-JP").format(item.price)}`)
  const features = selected.map((item) => `<ul>${item.highlights.map((feature) => `<li>${esc(l(feature))}</li>`).join("")}</ul>`)
  const stocks = selected.map(() => esc(l(IT_STORE_PAGE.stockNote)))
  tableRoot.innerHTML = `<table class="store-compare-table"><thead><tr><th></th>${names.map((name) => `<th scope="col">${name}</th>`).join("")}</tr></thead><tbody>
    ${row(IT_STORE_PAGE.compareRows.category, categories)}
    ${row(IT_STORE_PAGE.compareRows.price, prices, "store-compare-table__price")}
    ${row(IT_STORE_PAGE.compareRows.features, features)}
    ${row(IT_STORE_PAGE.compareRows.stock, stocks)}
  </tbody></table>`

  const quote = document.getElementById("store-compare-quote")
  if (quote) {
    const productLabel = selected.map((item) => `${l(item.name)} (${item.model})`).join(" / ")
    quote.href = `contact.html?product=${encodeURIComponent(productLabel)}#contact-form-title`
    quote.textContent = l(IT_STORE_PAGE.compareQuote)
  }
}

const renderStoreCompareBar = (products) => {
  const selectedCount = storeCatalogState.selected.size
  const bar = document.getElementById("store-compare-bar")
  if (bar) bar.hidden = selectedCount === 0
  setText("store-compare-count", siteLang === "ja" ? `${selectedCount}商品を選択中` : `${selectedCount} ${l(IT_STORE_PAGE.compareSelected)}`)
  setText("store-compare-open", l(IT_STORE_PAGE.compareOpen))
  setText("store-compare-clear", l(IT_STORE_PAGE.compareClear))
  setText("store-compare-title", l(IT_STORE_PAGE.compareTitle))
  const close = document.getElementById("store-compare-close")
  const backdrop = document.getElementById("store-compare-backdrop")
  if (close) close.setAttribute("aria-label", l(IT_STORE_PAGE.compareClose))
  if (backdrop) backdrop.setAttribute("aria-label", l(IT_STORE_PAGE.compareClose))
  renderStoreCompareTable(products)
}

const renderStoreCatalog = (products) => {
  const visible = getStoreVisibleProducts(products)
  const productRoot = document.getElementById("store-products-list")
  const empty = document.getElementById("store-products-empty")
  if (productRoot) productRoot.innerHTML = visible.map(renderStoreProductMarkup).join("")
  if (empty) {
    empty.hidden = visible.length !== 0
    empty.textContent = l(IT_STORE_PAGE.noResults)
  }
  setText("store-results-count", siteLang === "ja" ? `${visible.length}${l(IT_STORE_PAGE.resultLabel)}` : `${visible.length} ${l(IT_STORE_PAGE.resultLabel)}`)

  document.querySelectorAll("[data-store-category]").forEach((button) => {
    const active = button.dataset.storeCategory === storeCatalogState.category
    button.classList.toggle("is-active", active)
    button.setAttribute("aria-pressed", String(active))
  })

  document.querySelectorAll("[data-store-compare]").forEach((input) => {
    input.onchange = () => {
      if (input.checked && storeCatalogState.selected.size >= 3) {
        input.checked = false
        window.alert(l(IT_STORE_PAGE.compareLimit))
        return
      }
      if (input.checked) storeCatalogState.selected.add(input.value)
      else storeCatalogState.selected.delete(input.value)
      renderStoreCompareBar(products)
    }
  })
  renderStoreCompareBar(products)
}

const renderItStore = () => {
  const p = typeof IT_STORE_PAGE !== "undefined" ? IT_STORE_PAGE : null
  if (!p) return
  const products = typeof getItStoreProducts === "function" ? getItStoreProducts() : []

  document.title = l(p.pageTitle)
  setMeta("meta-description", l(p.metaDescription))
  setMeta("meta-keywords", l(p.metaKeywords))
  setMeta("og-title", l(p.pageTitle))
  setMeta("og-description", l(p.metaDescription))
  setText("breadcrumb-current", l(dafaultLanguage.nav.itStore))
  setText("store-label", l(p.heroLabel))
  setText("store-title", l(p.heroTitle))
  setText("store-lead", l(p.heroLead))
  setText("store-cta", l(p.heroCta))
  setText("store-cta2", l(p.heroCta2))
  setText("store-count", String(products.length))
  setText("store-count-label", l(p.countLabel))
  setText("store-products-label", l(p.productsLabel))
  setText("store-products-title", l(p.productsTitle))
  setText("store-products-lead", l(p.productsLead))
  setText("store-search-label", l(p.searchLabel))
  setText("store-sort-label", l(p.sortLabel))
  setText("store-process-label", l(p.processLabel))
  setText("store-process-title", l(p.processTitle))
  setText("store-notice-title", l(p.noticeTitle))
  setText("store-cta-title", l(p.ctaTitle))
  setText("store-cta-text", l(p.ctaText))
  setText("store-cta-btn", l(p.ctaBtn))

  const categoryRoot = document.getElementById("store-category-filter")
  if (categoryRoot) {
    categoryRoot.innerHTML = p.categories.map((category) => `<button type="button" data-store-category="${esc(category.key)}">${esc(l(category.label))}</button>`).join("")
    categoryRoot.onclick = (event) => {
      const button = event.target.closest("[data-store-category]")
      if (!button) return
      storeCatalogState.category = button.dataset.storeCategory
      renderStoreCatalog(products)
    }
  }

  const search = document.getElementById("store-search")
  if (search) {
    search.placeholder = l(p.searchPlaceholder)
    search.value = storeCatalogState.query
    search.oninput = () => {
      storeCatalogState.query = search.value
      renderStoreCatalog(products)
    }
  }

  const sort = document.getElementById("store-sort")
  if (sort) {
    sort.innerHTML = p.sortOptions.map((option) => `<option value="${esc(option.key)}">${esc(l(option.label))}</option>`).join("")
    sort.value = storeCatalogState.sort
    sort.onchange = () => {
      storeCatalogState.sort = sort.value
      renderStoreCatalog(products)
    }
  }

  renderStoreCatalog(products)

  const modal = document.getElementById("store-compare-modal")
  const openCompare = document.getElementById("store-compare-open")
  const clearCompare = document.getElementById("store-compare-clear")
  const closeCompare = document.getElementById("store-compare-close")
  const backdrop = document.getElementById("store-compare-backdrop")
  if (openCompare) openCompare.onclick = () => {
    renderStoreCompareTable(products)
    if (modal) modal.hidden = false
    document.body.classList.add("store-compare-open")
    closeCompare?.focus()
  }
  if (clearCompare) clearCompare.onclick = () => {
    storeCatalogState.selected.clear()
    renderStoreCatalog(products)
  }
  if (closeCompare) closeCompare.onclick = closeStoreCompareModal
  if (backdrop) backdrop.onclick = closeStoreCompareModal
  if (document.body.dataset.storeCompareEscapeBound !== "1") {
    document.body.dataset.storeCompareEscapeBound = "1"
    document.addEventListener("keydown", (event) => {
      if (event.key === "Escape") closeStoreCompareModal()
    })
  }

  const processRoot = document.getElementById("store-process-list")
  if (processRoot) {
    processRoot.innerHTML = p.process
      .map((step, index) => `<li class="store-process__item reveal">
        <span class="store-process__num">${String(index + 1).padStart(2, "0")}</span>
        <h3 class="store-process__item-title">${esc(l(step.title))}</h3>
        <p class="store-process__text">${esc(l(step.text))}</p>
      </li>`)
      .join("")
  }

  const noticeRoot = document.getElementById("store-notice-list")
  if (noticeRoot) noticeRoot.innerHTML = p.notices.map((notice) => `<li>${esc(l(notice))}</li>`).join("")
}

const renderAbout = () => {
  const p = dafaultLanguage.pages.about
  document.title = l(p.pageTitle)
  setMeta("meta-description", l(p.metaDescription))
  setMeta("meta-keywords", l(p.metaKeywords))
  setText("breadcrumb-current", l(dafaultLanguage.nav.about))
  setText("about-label", l(p.heroLabel))
  setText("about-title", l(p.heroTitle))
  setText("about-lead", l(p.heroLead))
  setText("about-overview-title", l(p.overviewTitle))
  setText("about-th-name", l(p.thName))
  setText("about-th-founded", l(p.thFounded))
  setText("about-th-place", l(p.thPlace))
  setText("about-th-business", l(p.thBusiness))
  setText("about-th-capital", l(p.thCapital))
  setText("about-team-title", l(dafaultLanguage.team.title))
  setText("about-team-lead", l(dafaultLanguage.team.subtitle))
  setText("about-team-cta", l(dafaultLanguage.pages.about.teamCta))

  setText("about-belief-title", l(dafaultLanguage.sectionLabels.philosophyHeading))
  setText("about-belief-1", l(dafaultLanguage.philosophy.philosophy1))
  setText("about-belief-2", l(dafaultLanguage.philosophy.philosophy2))
}

const renderInsights = () => {
  const p = dafaultLanguage.pages.insights
  document.title = l(p.pageTitle)
  setMeta("meta-description", l(p.metaDescription))
  setMeta("meta-keywords", l(p.metaKeywords))
  setMeta("og-title", l(p.pageTitle))
  setMeta("og-description", l(p.metaDescription))
  setText("breadcrumb-current", l(dafaultLanguage.nav.insights))
  setText("insights-label", l(p.heroLabel))
  setText("insights-title", l(dafaultLanguage.insights.heading))
  setText("insights-lead", l(dafaultLanguage.insights.lead))
  const articles = getInsightArticles()
  const noteEl = document.getElementById("insights-note")
  if (noteEl) {
    noteEl.textContent =
      articles.length > 0 ? "" : l(dafaultLanguage.insights.comingSoon)
    noteEl.style.display = articles.length > 0 ? "none" : ""
  }
  const root = document.getElementById("insights-list")
  if (root) {
    if (!articles.length) {
      root.innerHTML = `<p class="article-grid--empty">${esc(l(dafaultLanguage.insights.comingSoon))}</p>`
      return
    }
    root.innerHTML = articles.map((a) => renderInsightCardMarkup(a)).join("")
  }
}

const formatInsightDate = (iso) => {
  if (!iso) return ""
  const d = new Date(iso)
  if (siteLang === "en") {
    return d.toLocaleDateString("en-US", { year: "numeric", month: "short", day: "numeric" })
  }
  return `${d.getFullYear()}.${String(d.getMonth() + 1).padStart(2, "0")}.${String(d.getDate()).padStart(2, "0")}`
}

const renderInsightCardMarkup = (a, hrefPrefix = "insights/") => `
      <a class="article-card article-card--media article-card--link reveal" href="${hrefPrefix}${esc(a.slug)}.html">
        <div class="article-card__media">
          <img src="${esc(a.imageUrl || NAPIRE_MEDIA.workThumb)}" alt="" width="480" height="300" loading="lazy" />
        </div>
        <div class="article-card__body">
        <div class="article-card__meta">
          <span class="article-card__tag">${esc(l(a.tag))}</span>
          <span class="article-card__date"><span class="article-card__date-label">${esc(l(dafaultLanguage.home.insightsDateLabel))}</span> <time datetime="${esc(a.publishedAt)}">${esc(formatInsightDate(a.publishedAt))}</time></span>
        </div>
        <h2 class="article-card__title">${esc(l(a.title))}</h2>
        <p class="article-card__desc">${esc(l(a.description))}</p>
        </div>
      </a>`

const getInsightArticles = () =>
  typeof INSIGHT_ARTICLES !== "undefined" && INSIGHT_ARTICLES.length ? INSIGHT_ARTICLES : []

const getConsultingReportArticles = () =>
  typeof CONSULTING_REPORT_ARTICLES !== "undefined" && CONSULTING_REPORT_ARTICLES.length
    ? CONSULTING_REPORT_ARTICLES
    : []

const renderConsultingReportCardMarkup = (a, hrefPrefix = "consulting-reports/") => `
      <a class="article-card article-card--media article-card--link reveal" href="${hrefPrefix}${esc(a.slug)}.html">
        <div class="article-card__media">
          <img src="${esc(a.imageUrl || NAPIRE_MEDIA.workThumb)}" alt="" width="480" height="300" loading="lazy" />
        </div>
        <div class="article-card__body">
        <div class="article-card__meta">
          <span class="article-card__tag">${esc(l(a.tag))}</span>
          <span class="article-card__date"><span class="article-card__date-label">${esc(l(dafaultLanguage.home.insightsDateLabel))}</span> <time datetime="${esc(a.publishedAt)}">${esc(formatInsightDate(a.publishedAt))}</time></span>
        </div>
        <h2 class="article-card__title">${esc(l(a.title))}</h2>
        <p class="article-card__desc">${esc(l(a.description))}</p>
        </div>
      </a>`

const renderConsultingReports = () => {
  const p = dafaultLanguage.pages.consultingReports
  document.title = l(p.pageTitle)
  setMeta("meta-description", l(p.metaDescription))
  setMeta("meta-keywords", l(p.metaKeywords))
  setMeta("og-title", l(p.pageTitle))
  setMeta("og-description", l(p.metaDescription))
  setText("breadcrumb-current", l(dafaultLanguage.nav.reports))
  setText("reports-label", l(p.heroLabel))
  setText("reports-title", l(dafaultLanguage.consultingReports.heading))
  setText("reports-lead", l(dafaultLanguage.consultingReports.lead))
  const articles = getConsultingReportArticles()
  const noteEl = document.getElementById("reports-note")
  if (noteEl) {
    noteEl.textContent =
      articles.length > 0 ? "" : l(dafaultLanguage.consultingReports.comingSoon)
    noteEl.style.display = articles.length > 0 ? "none" : ""
  }
  const root = document.getElementById("reports-list")
  if (root) {
    if (!articles.length) {
      root.innerHTML = `<p class="article-grid--empty">${esc(l(dafaultLanguage.consultingReports.comingSoon))}</p>`
      return
    }
    root.innerHTML = articles.map((a) => renderConsultingReportCardMarkup(a)).join("")
  }
}

const getConsultingReportData = () => {
  const el = document.getElementById("consulting-report-data")
  if (!el) return null
  try {
    return JSON.parse(el.textContent)
  } catch {
    return null
  }
}

const renderConsultingReportArticle = () => {
  const article = getConsultingReportData()
  if (!article) return
  const suffix =
    siteLang === "en"
      ? " | Consulting Reports | NAPIRE Inc."
      : " | コンサルティングレポート | 株式会社NAPIRE"
  document.title = l(article.title) + suffix
  setMeta("meta-description", l(article.description))
  setMeta("meta-keywords", insightKeywords(article))
  setMeta("og-title", l(article.title))
  setMeta("og-description", l(article.description))
  setMeta("twitter-title", l(article.title))
  setMeta("twitter-description", l(article.description))
  setText("breadcrumb-reports", l(dafaultLanguage.nav.reports))
  setText("breadcrumb-current", l(article.title))
  setText("article-tag", l(article.tag))
  setText("article-title", l(article.title))
  setText("article-description", l(article.description))
  setText("article-date-label", l(dafaultLanguage.home.insightsDateLabel))
  const dateEl = document.getElementById("article-date")
  if (dateEl) {
    dateEl.textContent = formatInsightDate(article.publishedAt)
    dateEl.setAttribute("datetime", article.publishedAt || "")
  }
  const bodyEl = document.getElementById("article-body")
  if (bodyEl) bodyEl.innerHTML = l(article.content)
  const imgEl = document.getElementById("article-image")
  if (imgEl && article.imageUrl) imgEl.src = `../${article.imageUrl}`
  setText("article-back", siteLang === "en" ? "← Back to reports" : "← 一覧に戻る")

  const titleHidden = document.getElementById("report-gate-title-value")
  if (titleHidden) titleHidden.value = l(article.title)

  if (typeof applyReportGateI18n === "function") applyReportGateI18n()
  if (typeof bindReportGateForms === "function") bindReportGateForms()
}

const renderFaqItemMarkup = (item) => `
      <details class="faq-item reveal">
        <summary class="faq-item__summary">
          <span class="faq-item__q">${esc(l(item.q))}</span>
          <span class="faq-item__toggle" aria-hidden="true"><span class="faq-item__toggle-icon"></span></span>
        </summary>
        <div class="faq-item__answer">
          <p>${esc(l(item.a))}</p>
        </div>
      </details>`

const getInsightArticleData = () => {
  const el = document.getElementById("insight-article-data")
  if (!el) return null
  try {
    return JSON.parse(el.textContent)
  } catch {
    return null
  }
}

const renderInsightArticle = () => {
  const article = getInsightArticleData()
  if (!article) return
  const p = dafaultLanguage.pages.insights
  const suffix = siteLang === "en" ? " | Insights | NAPIRE Inc." : " | インサイト・コラム | 株式会社NAPIRE"
  document.title = l(article.title) + suffix
  setMeta("meta-description", l(article.description))
  setMeta("meta-keywords", insightKeywords(article))
  setMeta("og-title", l(article.title))
  setMeta("og-description", l(article.description))
  setMeta("twitter-title", l(article.title))
  setMeta("twitter-description", l(article.description))
  setText("breadcrumb-insights", l(dafaultLanguage.nav.insights))
  setText("breadcrumb-current", l(article.title))
  setText("article-tag", l(article.tag))
  setText("article-title", l(article.title))
  setText("article-description", l(article.description))
  setText("article-date-label", l(dafaultLanguage.home.insightsDateLabel))
  const dateEl = document.getElementById("article-date")
  if (dateEl) {
    dateEl.textContent = formatInsightDate(article.publishedAt)
    dateEl.setAttribute("datetime", article.publishedAt || "")
  }
  const bodyEl = document.getElementById("article-body")
  if (bodyEl) bodyEl.innerHTML = l(article.content)
  const imgEl = document.getElementById("article-image")
  if (imgEl && article.imageUrl) imgEl.src = `../${article.imageUrl}`
  setText("article-back", siteLang === "en" ? "← Back to insights" : "← 一覧に戻る")
}

const renderServicePage = (key) => {
  const p = servicePages[key]
  if (!p) return
  document.title = l(p.pageTitle)
  setMeta("meta-description", l(p.metaDescription))
  setMeta("meta-keywords", l(p.keywords))
  setMeta("og-title", l(p.pageTitle))
  setMeta("og-description", l(p.metaDescription))
  setText("breadcrumb-current", l(p.pageTitle).split("|")[0].trim())

  setText("page-label", l(p.hero.eyebrow))
  setText("page-title", l(p.hero.title))
  setText("page-lead", l(p.hero.lead))
  setText("page-cta", l(p.hero.cta))

  setText("questions-title", l(p.questions.heading))
  const q = document.getElementById("questions-list")
  if (q) {
    q.innerHTML = p.questions.items
      .map(
        (item) => `
      <article class="card reveal">
        <h3 class="card__title">${esc(l(item.q))}</h3>
        <p class="card__text">${esc(l(item.a))}</p>
      </article>`
      )
      .join("")
  }

  setText("services-title", l(p.services.heading))
  const s = document.getElementById("services-grid")
  if (s) {
    s.innerHTML = p.services.items
      .map(
        (item, i) => `
      <article class="card reveal">
        <span class="card__tag">${String(i + 1).padStart(2, "0")}</span>
        <h3 class="card__title">${esc(l(item.title))}</h3>
        <p class="card__text">${esc(l(item.desc))}</p>
      </article>`
      )
      .join("")
  }

  setText("process-title", l(p.process.heading))
  const pr = document.getElementById("process-steps")
  if (pr) {
    pr.innerHTML = p.process.steps
      .map(
        (step) => `
      <article class="process-step reveal">
        <p class="process-step__num">${esc(l(step.title).split(" ")[0])}</p>
        <h3 class="process-step__title">${esc(l(step.title))}</h3>
        <p class="process-step__text">${esc(l(step.desc))}</p>
      </article>`
      )
      .join("")
  }

  setText("why-title", l(p.why.heading))
  const w = document.getElementById("why-grid")
  if (w) {
    w.innerHTML = p.why.items
      .map(
        (item) => `
      <article class="card reveal">
        <h3 class="card__title">${esc(l(item.title))}</h3>
        <p class="card__text">${esc(l(item.body))}</p>
      </article>`
      )
      .join("")
  }

  setText("faq-title", l(p.faq.heading))
  const f = document.getElementById("faq-list")
  if (f) {
    f.innerHTML = p.faq.items.map((item) => renderFaqItemMarkup(item)).join("")
  }

  setText("page-cta-title", l(p.cta.heading))
  setText("page-cta-text", l(p.cta.body))
  setText("page-cta-btn", l(p.cta?.button || dafaultLanguage.contact.buttonText))
}

const memberImage = (id) => NAPIRE_MEDIA.team[id] || NAPIRE_MEDIA.aboutVisual

const la = (obj) => (obj && (obj[siteLang] || obj.ja)) || []

const normalizeTag = (s) =>
  String(s)
    .toLowerCase()
    .replace(/[・／/,&\s]+/g, "")
    .replace(/コンサルタント/g, "コンサル")
    .replace(/consultant/g, "consulting")

const filterRoleTags = (tags, roleText) => {
  const roleNorm = normalizeTag(roleText)
  const roleParts = String(roleText)
    .split(/[・／/,&\s]+/)
    .map((p) => normalizeTag(p))
    .filter((p) => p.length > 1)

  return tags.filter((tag) => {
    const tagNorm = normalizeTag(tag)
    if (!tagNorm) return false
    if (roleNorm.includes(tagNorm) || tagNorm.includes(roleNorm)) return false
    return !roleParts.some((part) => part.includes(tagNorm) || tagNorm.includes(part))
  })
}

const memberTags = (m) => filterRoleTags(la(m.tags), l(m.role))

const renderTeam = () => {
  const t = teamMembers
  document.title = l(t.pageTitle)
  setMeta("meta-description", l(t.metaDescription))
  setMeta("meta-keywords", l(t.metaKeywords))
  setText("breadcrumb-current", l(dafaultLanguage.nav.team))
  setText("team-label", l(t.hero.eyebrow))
  setText("team-title", l(t.hero.title))
  setText("team-lead", l(t.hero.lead))
  setText("team-overview-title", l(t.overviewLabel))
  setText("team-cta-title", l(dafaultLanguage.contact.heading))
  setText("team-cta-text", l(dafaultLanguage.contact.description))
  setText("team-cta-btn", l(dafaultLanguage.contact.buttonText))

  const overview = document.getElementById("team-overview")
  if (overview) {
    overview.innerHTML = t.members
      .map(
        (m) => `
      <a class="team-card reveal" href="#member-${m.id}">
        <div class="team-card__photo">
          <img src="${memberImage(m.id)}" alt="" width="400" height="400" loading="lazy" />
        </div>
        <div class="team-card__body">
          <h3 class="team-card__role">${esc(l(m.role))}</h3>
          <div class="team-card__tags">${memberTags(m)
            .map((tag) => `<span>${esc(tag)}</span>`)
            .join("")}</div>
        </div>
      </a>`
      )
      .join("")
  }

  const detail = document.getElementById("team-members")
  if (detail) {
    detail.innerHTML = t.members
      .map(
        (m, i) => `
      <section class="member-profile" id="member-${m.id}">
        <div class="container">
          <div class="member-profile__grid reveal">
            <div class="member-profile__photo">
              <img src="${memberImage(m.id)}" alt="" width="560" height="560" loading="lazy" />
            </div>
            <div class="member-profile__content">
              <h2 class="member-profile__role">${esc(l(m.role))}</h2>
              <div class="member-profile__tags">${memberTags(m)
                .map((tag) => `<span>${esc(tag)}</span>`)
                .join("")}</div>
              <h3 class="member-profile__bio-title">${esc(l(t.bioLabel))}</h3>
              <ul class="member-profile__bio">${la(m.bio)
                .map((line) => `<li>${esc(line)}</li>`)
                .join("")}</ul>
              <h3 class="member-profile__projects-title">${esc(l(t.projectsLabel))}</h3>
              <div class="member-table-wrap">
                <table class="member-table">
                  <thead>
                    <tr>
                      <th>${esc(l(t.table.role))}</th>
                      <th>${esc(l(t.table.client))}</th>
                      <th>${esc(l(t.table.theme))}</th>
                      <th>${esc(l(t.table.detail))}</th>
                    </tr>
                  </thead>
                  <tbody>
                    ${m.projects
                      .map(
                        (p) => `
                    <tr>
                      <td class="member-table__role" data-label="${esc(l(t.table.role))}">${esc(l(p.role))}</td>
                      <td data-label="${esc(l(t.table.client))}">${esc(l(p.client))}</td>
                      <td data-label="${esc(l(t.table.theme))}">${esc(l(p.theme))}</td>
                      <td data-label="${esc(l(t.table.detail))}">${esc(l(p.detail))}</td>
                    </tr>`
                      )
                      .join("")}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </section>`
      )
      .join("")
  }
}

const renderContact = () => {
  const p = dafaultLanguage.pages.contact
  const c = dafaultLanguage.contact
  document.title = l(p.pageTitle)
  setMeta("meta-description", l(p.metaDescription))
  setMeta("meta-keywords", l(p.metaKeywords))
  setText("breadcrumb-current", l(dafaultLanguage.nav.contact))
  setText("contact-hero-label", l(p.heroLabel))
  setText("contact-hero-title", l(p.heroTitle))
  setText("contact-hero-lead", l(c.description))
  setText("contact-form-title", l(c.heading))
  setText("contact-form-note", l(p.formNote))

  const iframe = document.getElementById("contact-form-iframe")
  const selectedProduct = new URLSearchParams(window.location.search).get("product")?.trim().slice(0, 180) || ""
  const context = document.getElementById("contact-product-context")
  if (context) context.classList.toggle("is-visible", Boolean(selectedProduct))
  if (selectedProduct) {
    setText("contact-product-label", l(p.selectedProductLabel))
    setText("contact-product-name", selectedProduct)
    setText("contact-product-note", l(p.selectedProductNote))
  }
  if (iframe) {
    if (selectedProduct) {
      const details = `【IT機器の購入・お見積相談】\n商品：${selectedProduct}\n数量：\nお届け先：\n希望時期：`
      const separator = c.formUrl.includes("?") ? "&" : "?"
      iframe.src = `${c.formUrl}${separator}usp=pp_url&entry.1516870264=${encodeURIComponent("お見積もりのご依頼")}&entry.668243907=${encodeURIComponent(details)}`
    } else {
      iframe.src = c.formUrl
    }
    iframe.title = l(c.formLink)
  }
}

const initSiteHeader = (lang) => {
  siteLang = lang
  document.documentElement.lang = lang === "ja" ? "ja" : "en"

  const jaBtn = document.getElementById("jaButton")
  const enBtn = document.getElementById("enButton")
  if (jaBtn && enBtn) {
    jaBtn.classList.toggle("lang-btn--active", lang === "ja")
    enBtn.classList.toggle("lang-btn--active", lang === "en")
  }

  renderSharedNav()
  document.documentElement.classList.add("header-ready")
}

const initSiteLang = (lang, page) => {
  savePreferredLang(lang)
  initSiteHeader(lang)
  renderFooterCompany()
  bindLangSwitch()

  const resolvedPage = page || document.body?.dataset?.page || ""

  if (resolvedPage === "home") renderHome()
  else if (resolvedPage === "work") renderWork()
  else if (resolvedPage === "products") renderProducts()
  else if (resolvedPage === "itStore") renderItStore()
  else if (resolvedPage === "about") renderAbout()
  else if (resolvedPage === "team") renderTeam()
  else if (resolvedPage === "contact") renderContact()
  else if (resolvedPage === "insights") renderInsights()
  else if (resolvedPage === "insightArticle") renderInsightArticle()
  else if (resolvedPage === "consultingReports") renderConsultingReports()
  else if (resolvedPage === "consultingReportArticle") renderConsultingReportArticle()
  else if (resolvedPage === "drone") renderServicePage("drone")
  else if (resolvedPage === "aiDx") renderServicePage("aiDx")
  else if (resolvedPage === "saasCloud") renderServicePage("saasCloud")

  showRevealsAfterLangSwitch()
  document.dispatchEvent(new CustomEvent("napire-lang-updated"))
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", bindLangSwitch)
} else {
  bindLangSwitch()
}
